<mat-form-field appearance="fill">
  <ng-template #project>Project</ng-template>
  <mat-label><span *ngIf="(placeholder && !projectCtrl.value) else project">All projects</span></mat-label>
  <mat-select [formControl]="projectCtrl">
    <mat-option>All projects</mat-option>
    <mat-option *ngFor="let project of projects" [value]="project">{{ project.name}}</mat-option>
  </mat-select>
</mat-form-field>
